﻿import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { File, FileElement, Folder } from ".";
import React, { useState } from "react";

export interface IFolderElementProps {
    bindFile: (file: File) => void;
    contents: Folder;
    refresh: () => void;
    smartBoardsUrl: string;
}

export type FolderElement = "open" | "collapse";

export const FolderElement: React.FunctionComponent<IFolderElementProps> = (
    props,
): React.ReactElement => {
    const [height, setHeight] = useState<FolderElement>(`collapse`);

    const fileOnClick = (): void => {
        const newHeight: FolderElement =
            height === `open` ? `collapse` : `open`;

        setHeight(newHeight);
    };

    const folders: React.ReactNode[] = [];

    for (let i = 0; i < props.contents.folders.length; i++) {
        folders.push(
            <FolderElement
                key={props.contents.folders[i].name}
                {...props}
                contents={props.contents.folders[i]}
            />,
        );
    }

    const files: React.ReactNode[] = [];

    for (let i = 0; i < props.contents.files.length; i++) {
        files.push(
            <FileElement
                key={props.contents.files[i].name}
                {...props}
                content={props.contents.files[i]}
            />,
        );
    }

    return (
        <React.Fragment>
            <ContextMenuTrigger id={`folder-${props.contents.name}`}>
                <div>
                    <div
                        className={`treeitem treeitem-folder`}
                        onClick={fileOnClick}
                    >
                        <div className={`folder-icon`}>
                            <img src={`/Images/FolderIcon.svg`} />
                        </div>
                        {props.contents.name}
                    </div>
                    <div className={`treeitem-content ${height}`}>
                        {folders}
                        {files}
                    </div>
                </div>
            </ContextMenuTrigger>
            <ContextMenu id={`folder-${props.contents.name}`}>
                <MenuItem>
                    <div className={`contextmenu-item`}>New Folder</div>
                </MenuItem>
                <MenuItem>
                    <div className={`contextmenu-item`}>Rename</div>
                </MenuItem>
                <MenuItem>
                    <div className={`contextmenu-item`}>Move To...</div>
                </MenuItem>
                <MenuItem>
                    <div className={`contextmenu-item`}>Delete</div>
                </MenuItem>
            </ContextMenu>
        </React.Fragment>
    );
};
